'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const print_form_1 = require("./sales/print-form");
const files_accordion_1 = require("./sales/files-accordion");
$(() => {
    new print_form_1.SalesPrintForm();
    new files_accordion_1.FilesAccordion();
});
